module.exports = __webpack_public_path__ + "img/WeStore_logo-white-footer-arabic-w208.3b555a37.png";